import { format, parseISO } from 'date-fns'
import type { VencimientoCalendarioOpcion } from '@/types/vencimientos'

/**
 * Etiqueta de una fila del calendario en el selector de prórrogas (ORR-277):
 * `27/07/2026 · año 2025 · todas las terminaciones`.
 *
 * El período va TAL CUAL está guardado, sin reformatear: es el mismo texto contra el que después
 * compara el match de la prórroga (`pf.periodo = vac.periodo`). Normalizarlo acá haría que el
 * usuario elija una cosa y se guarde otra.
 *
 * Una terminación que lista los 10 dígitos significa lo mismo que NULL: todas.
 */
export function etiquetaVencimiento(v: VencimientoCalendarioOpcion): string {
  const fecha = format(parseISO(v.fecha_vencimiento), 'dd/MM/yyyy')
  const digitos = v.terminacion_cuit?.split('-').filter(Boolean) ?? []
  const terminacion =
    digitos.length === 0 || digitos.length === 10
      ? 'todas las terminaciones'
      : `terminación ${v.terminacion_cuit}`
  return `${fecha} · ${v.periodo} · ${terminacion}`
}
